import { render, staticRenderFns } from "./SocialIcons.vue?vue&type=template&id=4fad5c4a"
import script from "./SocialIcons.vue?vue&type=script&lang=js"
export * from "./SocialIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports